export enum ETargetType {
  NURSING_STAFF = "nursing_staff",
  USER_ADMIN = "user_admin",
}
